import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CustomTranslationNoOptionsStyled } from "../custom-translations.styled";

interface ITranslationNoOptionsProps {
  /** The trimmed search query the user typed. */
  query: string;
  /** Whether an override for this query already exists. */
  alreadyExists: boolean;
  /** Creates a custom translation for `query`. */
  onAddNew: () => void;
}

/**
 * Rendered inside the path autocomplete popup when the search has no matching
 * key. Lets the user create a custom translation for a path that does not exist
 * in the base bundle.
 */
export const TranslationNoOptions: FC<ITranslationNoOptionsProps> = ({
  query,
  alreadyExists,
  onAddNew,
}) => {
  const { t } = useTranslation();

  return (
    <CustomTranslationNoOptionsStyled>
      <span className="ct-no-options__text">{t("general.NO_RESULTS")}</span>

      {!!query &&
        (alreadyExists ? (
          <span className="ct-no-options__note">
            {t("systemParam.customTranslations.alreadyAdded")}
          </span>
        ) : (
          <Button
            size="small"
            className="ct-no-options__add"
            startIcon={<Add fontSize="small" />}
            onMouseDown={event => event.preventDefault()}
            onClick={onAddNew}
          >
            {t("systemParam.customTranslations.createMissing", { path: query })}
          </Button>
        ))}
    </CustomTranslationNoOptionsStyled>
  );
};
